import { render, staticRenderFns } from "./UserFormCard.vue?vue&type=template&id=db08307a&scoped=true&"
import script from "./UserFormCard.vue?vue&type=script&lang=ts&"
export * from "./UserFormCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserFormCard.vue?vue&type=style&index=0&id=db08307a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db08307a",
  null
  
)

export default component.exports